import ConflictingTeamsListModalContent from "./ConflictingTeamsListModalContent";
import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";

interface ConflictingTeamsListModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currency?: string;
}

/**
 * Wrapper component that provides required context for DataTable pagination.
 * The inner component uses useTablePagination which requires DatatableContextProvider.
 */
const ConflictingTeamsListModal = (props: ConflictingTeamsListModalProps) => {
  return (
    <DatatableContextProvider>
      <ConflictingTeamsListModalContent {...props} />
    </DatatableContextProvider>
  );
};

export default ConflictingTeamsListModal;
